
export const stringToDate = (stringDate: string) => {
    let parts = stringDate.split('-');            
    return  new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]))
}